import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateFreight } from '../../store/ducks/tables/actions';
import { Distributor, Driver } from '../../store/ducks/tables/types';
import { PaymentOrderStatus } from '../../types/drawer.types';
import { Freights } from '../../store/ducks/freight/types';

export interface GetPaymentOrdersResponse {
  page: string;
  rows: GetPaymentOrdersResponseRow[];
  totalRecords: number;
}

export interface GetPaymentOrdersResponseRow {
  paymentOrderId: string;
  amount: string;
  currency: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  nfeUrl: null;
  status: PaymentOrderStatus;
  distributor: Distributor;
  driver: Driver;
  freights: Freights[];
}

export default function useGetPaymentOrders() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page?: number;
    rowsPerPage?: number;
    status?: string;
  }): Promise<GetPaymentOrdersResponse | undefined> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/payment-orders', {
        params: {
          page: params.page,
          rowsPerPage: params.rowsPerPage || 20,
          status: params.status == 'Todos' ? undefined : params.status,
        },
      });

      if (response.status === 200) {
        dispatch(populateFreight(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
